import { render, staticRenderFns } from "./ProductCategoryAreaComponent.vue?vue&type=template&id=5d8b64de&lang=pug&"
import script from "./ProductCategoryAreaComponent.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports